import React, { Fragment, useEffect } from "react"
import { renderRoutes } from "react-router-config"
import { setTitle } from "../utils"

const Layout = ({ route, location }) => {
  useEffect(() => {
    setTitle(location.pathname)
  }, [location])
  return <Fragment>{renderRoutes(route && route.routes)}</Fragment>
}

export default Layout
